import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileAutoInsuranceContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return contextType === SharedFileRequestContextType.AutoInsuranceCard;
}
